import React from 'react'
import { dateToString } from '../../../utils/dateUtils'

const ChartTooltip = ({ active, payload, label, roundValues = true }) => {
    if (active) {
        return (
            <div className="customTooltip">
                <p className="customTooltipLabel">{dateToString(label)}</p>
                <ul className="customTooltipList">
                    {payload &&
                        payload.map((x, idx) =>
                            x.name !== 'NoTooltipItem' ? (
                                <li style={{ color: x.color }} key={idx}>
                                    <span className="customTooltipItemName">
                                        {x.name}
                                    </span>
                                    <span> : </span>
                                    <span className="customTooltipItemValue">
                                        {roundValues
                                            ? Math.round(x.value * 100) / 100
                                            : x.value}
                                    </span>
                                    <span className="customTooltipItemUnit">{` ${x.unit}`}</span>
                                </li>
                            ) : null
                        )}
                </ul>
            </div>
        )
    }
    return null
}

export default ChartTooltip
